import { Component } from '@angular/core';

@Component({
  selector: 'ifp-id-verse-completed-callback',
  template: '',
  standalone: false,
})
export class IdVerseCompletedCallbackComponent {}